import { reactive, Ref,ref, toRefs } from 'vue';

interface BaseApi<T> {
	data: T | null;
	error: any;
    hasLoaded: boolean;
	isLoading: boolean;
    requestedUrl: any;
}

export function useApiGet<T>() {
    const state = reactive<BaseApi<T>>({
        data: null,
        error: null,
        hasLoaded: false,
        isLoading: false,
        requestedUrl: null
    });

    const getData = async (url: string): Promise<void> => {
        state.isLoading = true;
        state.error = null;

        const options = {
            headers: {
                //'Access-Control-Allow-Origin': '*',
            },
        };

        try {
            state.data = await fetch(url, options).then(async (response) => response.json());
            state.requestedUrl = url;
        } catch (error) {
            state.error = error;
        } finally {
            state.hasLoaded = true;
            state.isLoading = false;
        }
    };

    return {
        ...toRefs(state),
        getData,
    };
}

export function useApiPost<T>() {
    const state = reactive<BaseApi<T>>({
        data: null,
        error: null,
        hasLoaded: false,
        isLoading: false,
        requestedUrl: null
    });

    const postData = async (url: string, body: Record<string, unknown>): Promise<void> => {
        state.isLoading = true;
        state.error = null;

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        };

        try {
            state.data = await fetch(url, options).then(async (response) => response.json());
            state.requestedUrl = url;
        } catch (error) {
            state.error = error;
        } finally {
            state.isLoading = false;
            state.hasLoaded = true;
        }
    };

    return {
        ...toRefs(state),
        postData,
    };
}
